window.ezfy = window.ezfy || {};

ezfy = (function () {
  window.discounts = [
    {
      percentage: 20,
      amount: `20%`,
      coupon: "DVJTI5KV1I85",
    },
  ];

  function _loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s;
      s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function _extractTextBetween(text, start, end) {
    if (!start || !end) {
      throw new Error(`Please add a "start" and "end" parameter`);
    }

    return text.split(start)[1].split(end)[0];
  }

  function _loadStyle(src) {
    return new Promise(function (resolve, reject) {
      let link = document.createElement("link");
      link.href = src;
      link.rel = "stylesheet";

      link.onload = () => resolve(link);
      link.onerror = () => reject(new Error(`Style load error for ${src}`));

      document.head.append(link);
    });
  }

  function _moveDOMElement(parent, child) {
    document.querySelector(parent).appendChild(document.querySelector(child));
  }

  function isProductsPage() {
    return /products\//.test(window.location.href);
  }

  function _isCartPage() {
    return /cart/.test(window.location.href);
  }

  function isCollectionsPage() {
    return /\/collections\/.*(\/)?$/.test(window.location.pathname);
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function _waitForElement(selector, delay = 50, tries = 100) {
    const element = document.querySelector(selector);

    if (!window[`__${selector}`]) {
      window[`__${selector}`] = 0;
      window[`__${selector}__delay`] = delay;
      window[`__${selector}__tries`] = tries;
    }

    function _search() {
      return new Promise((resolve) => {
        window[`__${selector}`]++;
        setTimeout(resolve, window[`__${selector}__delay`]);
      });
    }

    if (element === null) {
      if (window[`__${selector}`] >= window[`__${selector}__tries`]) {
        window[`__${selector}`] = 0;
        return Promise.resolve(null);
      }

      return _search().then(() => _waitForElement(selector));
    } else {
      return Promise.resolve(element);
    }
  }

  function _addStyle(styleString) {
    const style = document.createElement("style");
    style.textContent = styleString;
    document.head.append(style);
  }

  function test() {
    fetch("https://xwh1tv-pp.myshopify.com/admin/api/2024-01/customers.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Access-Token": "c0937ef4d3fa47f5d2cb2eca77c85e3a",
      },
      body: JSON.stringify({
        customer: {
          email: "customer@example.com",
          first_name: "First",
          last_name: "Last",
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => console.log(data))
      .catch((error) => console.error("Error:", error));
  }

  function oneQuantityPerProduct() {
    const cartForm = document.querySelectorAll('form[action="/cart/change"]');

    if (cartForm) {
      cartForm.forEach((form) => {
        form.addEventListener("submit", (e) => {
          const quantityField = form.querySelector('[name="quantity"]');
          if (quantityField && quantityField.value > 1) {
            e.preventDefault();
            alert("Only one quantity of each product is allowed.");
            quantityField.value = 1;
          }
        });
      });
    }
  }

  function redirectOldWebsiteShop() {
    const currentUrl = window.location.href;

    if (currentUrl.includes("/shop/")) {
      const productName = currentUrl.split("/shop/")[1].split("?")[0];

      if (productName) {
        // Redirect to the new URL
        const newUrl = `/products/${productName}`;
        window.location.href = newUrl;
      }
    }
  }

  function redirectOldWebsiteBlog() {
    if (
      window.location.href.includes(
        `refresh-atheme-vertical-thumbnails-with-arrow-navigation-on-product-pages-no-apps`
      )
    ) {
      /* TODO - redirect to dawn slider pro */
    }
  }

  function isBlogPage() {
    return (
      /blogs\/shopify-tutorials/.test(window.location.href) ||
      /blogs\/case-studies/.test(window.location.href)
    );
  }

  function wrapGistsWithDiv() {
    const $text = document.querySelector(`.article-template__content`);

    if (!$text) {
      return;
    }

    const text = $text.innerHTML;

    if (!text.includes(`[gist]`)) {
      return;
    }

    const result = text.replace(/\[gist\](.*?)\[\/gist\]/g, (match, id) => {
      return `<div data-gist-id="${id}"></div>`;
    });

    $text.innerHTML = result;
  }

  function renderGistsDynamically() {
    var $gists = window.document.querySelectorAll(`[data-gist-id]`);

    for (var [i, each] of $gists.entries()) {
      const gistId = each.getAttribute("data-gist-id");

      // Create an iframe, append it to this document where specified
      var gistFrame = window.document.createElement("iframe");
      gistFrame.setAttribute("width", "100%");
      gistFrame.classList = `gistFrame gistFrame--${i}`;
      gistFrame.setAttribute("scrolling", "yes");
      gistFrame.setAttribute("width", "100%");

      var $zone = each;
      $zone.innerHTML = "";
      $zone.appendChild(gistFrame);

      // Create the iframe's document
      var gistFrameHTML =
        "<html><body><scr" +
        `ipt type="text/javascript" src="https://gist.github.com/dpw1/` +
        gistId +
        '.js"></sc' +
        "ript></body></html>";

      // Set iframe's document with a trigger for this document to adjust the height
      var gistFrameDoc = gistFrame.document;

      if (gistFrame.contentDocument) {
        gistFrameDoc = gistFrame.contentDocument;
      } else if (gistFrame.contentWindow) {
        gistFrameDoc = gistFrame.contentWindow.document;
      }

      gistFrameDoc.open();
      gistFrameDoc.writeln(gistFrameHTML);
      gistFrameDoc.close();

      /* Add height to iframe */
      const $iframe = document.querySelector(`.gistFrame--${i}`);

      $iframe.addEventListener("load", async function (e) {
        try {
          var height = $iframe.contentWindow.document.body.scrollHeight;
          $iframe.style.height = `${height}px`;

          /* ======== */
          var $html = gistFrameDoc;

          if (!$html) {
            console.log("lll no $html");
          }

          await sleep(1000);

          console.log("lll html", $html);

          var $meta = $html.querySelector(`.gist-meta a`);

          if (!$meta) {
            console.log("lll no $eta");
          }

          var code = $meta.getAttribute("href");

          const gist = await getPublicGist(gistId);
          const copy = gist.files[Object.keys(gist.files)[0]].content;
          const $el = $iframe.closest(`[data-gist-id]`);

          try {
            $el.insertAdjacentHTML(
              `afterbegin`,
              `<a id="GistButton-${gistId}"  href="#" class="GistRawCode btn" >Copy code</a>`
            );
          } catch (err) {
            $zone.insertAdjacentHTML(
              `afterbegin`,
              `<a id="GistButton-${gistId}"  href="#" class="GistRawCode btn" >Copy code</a>`
            );
          }

          await sleep(50);

          const $button = document.querySelector(`[id='GistButton-${gistId}']`);

          $button.addEventListener("click", async (e) => {
            e.preventDefault();
            const $this = e.target;

            const text = $this.textContent.trim();

            $this.textContent = "Copied!";

            copyToClipboard(copy);

            await sleep(2000);

            $this.textContent = text;
          });
        } catch (err) {
          console.log("lll iframe error: ", err);
        }
      });
    }
  }

  function getPublicGist(gistId) {
    return new Promise((resolve, reject) => {
      const url = `https://api.github.com/gists/${gistId}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          resolve(data); // Resolve the promise with the Gist data
        })
        .catch((error) => {
          // Reject the promise with the error
          console.error("Error:", error);
          reject(error);
        });
    });
  }

  function injectNoticeBox() {
    try {
      const html = `<div class="NoticeBox NoticeBox--info"><p>This tutorial is compatible only with Shopify's official free themes: <b>Dawn, Refresh, Colorblock, Taste, Ride, Studio, Crave, Origin, Spotlight, Publisher, Sense &amp; Craft.</b></p></div>`;

      const $text = document.querySelector(
        `.article-template__content, [data-template-name="product"] .product__description`
      );
      $text.innerHTML = $text.innerHTML.replaceAll(`[noticebox]`, html);
    } catch (er) {
      console.warn(`No [noticebox] was detected.`);
    }
  }

  async function addDiscountCoupon(products = null) {
    return;
    let discount;
    if (products === null) {
      throw new Error(`No cart. (addDiscountCoupon)`);
    }

    await _waitForElement(`.ec-cart-summary:not([class*='wait'])`);

    const $discount = await _waitForElement(
      `[class*='cart-coupon'] > a`,
      100,
      25
    );

    if (products.length === 2) {
      discount = window.discounts[0].coupon;
    } else if (products.length >= 3) {
      discount = window.discounts[1].coupon;
    }

    if (!$discount) return;

    const $cancel = document.querySelector(`.ec-cart-coupon__button--cancel`);
    if ($cancel) $cancel.click();

    const $forms = document.querySelectorAll(`[class*='ec-cart__discount']`);
    for (const each of $forms) {
      const $redeem = each.querySelector(`[class*='cart-coupon'] > a`);
      if (!$redeem) continue;

      $redeem.click();
      await sleep(50);

      const $input = each.querySelector(`input.form-control__text`);
      if (!$input) continue;

      await sleep(25);

      $input.value = discount;
      $input.dispatchEvent(
        new Event("input", { bubbles: true, cancelable: true })
      );

      await sleep(500);

      const $button = each.querySelector(
        `.ec-cart-coupon__button--apply button`
      );
      if ($button) $button.click();
    }

    if (document.querySelector(`[class*='--discount-coupon']`)) {
      window.discountCodeApplied = true;
    }
  }

  function lazyLoadYoutubeIframe() {
    const iframes = document.querySelectorAll("iframe[data-src]");

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const iframe = entry.target;
          iframe.src = iframe.dataset.src;
          iframe.removeAttribute("data-src");
          obs.unobserve(iframe);
        }
      });
    });

    iframes.forEach((iframe) => observer.observe(iframe));
  }

  function playThumbnailVideo() {
    /* not being used */
    const $elements = document.querySelectorAll(".card--has-video");

    if (!$elements) return;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Trigger when 50% of the element is in view
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $parent = entry.target;

        if (!entry.isIntersecting) return stopVideo($parent);

        let video = $parent.querySelector(".video");
        const $link = $parent.querySelector("a");
        const $container = $parent.querySelector(".media");
        const $img = $container?.querySelector("img");
        const videoURL = $parent.getAttribute("data-video-demo");

        if (!$container || !$img || !videoURL) return;

        if (!video) {
          const videoHTML = `
          <video class="video" muted loop autoplay>
            <source src="${videoURL}" type="video/mp4">
          </video>
        `;

          console.log("playing video!");
          $container.insertAdjacentHTML("beforeend", videoHTML);
          video = $container.querySelector(".video");
        }

        $img.style.opacity = "0";
      });
    }, options);

    $elements.forEach(($parent) => observer.observe($parent));

    function stopVideo($parent) {
      const video = $parent.querySelector(".video");
      const $img = $parent.querySelector(".media img");
      if (video) {
        video.pause();
        video.remove();
      }
      if ($img) $img.style.opacity = "1";
    }
  }

  function _loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s;
      s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  async function loadTippy() {
    return new Promise(async (resolve) => {
      if (window.hasOwnProperty(`tippy`)) {
        resolve();
        return;
      }

      await _loadScript(
        `https://cdnjs.cloudflare.com/ajax/libs/popper.js/2.9.2/umd/popper.min.js`
      );
      await _loadScript(
        `https://cdnjs.cloudflare.com/ajax/libs/tippy.js/6.3.7/tippy-bundle.umd.min.js`
      );

      resolve();
    });
  }

  function productPageDropdown() {
    const dropdownTitles = document.querySelectorAll(".dropdown-title");

    dropdownTitles.forEach((title) => {
      title.addEventListener("click", (e) => {
        e.preventDefault();
        title.classList.toggle("dropdown-title--active");
      });
    });
  }

  function handleHeaderClick() {
    const scroll = [
      {
        handle: "about",
        scrollTo: "",
      },
    ];
    const $items = document.querySelectorAll(`.header__menu-item[data-handle]`);

    if (!$items) {
      return;
    }

    for (var each of $items) {
      each.addEventListener(`click`, function (e) {
        const hanlde = e.getAttribute;
      });
    }
  }

  function scrollTo(selector, offset = 0) {
    const element = document.querySelector(selector);
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  function cleanTabsInProductPageDescription() {
    const $links = document.querySelectorAll(
      '.product__description p > a[class*="dropdown"]'
    );

    $links.forEach((link) => {
      const parentP = link.parentElement;
      if (parentP && parentP.tagName === "P") {
        parentP.replaceWith(link); // Replace <p> with <a>
      }
    });
  }

  function initTooltips() {
    if (!window.hasOwnProperty("tippy")) {
      console.error(`Tippy is not loaded.`);
      return;
    }

    var loadedTippy = tippy("[data-tippy-content]", { placement: "top" });

    console.log(`Loaded ${loadedTippy.length} tippy(s).`);
  }

  function copyToClipboard(text) {
    window.ezfy
      .showToast(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="15px" height="15px" viewBox="0 0 305.002 305.002" xml:space="preserve">
<g>
	<g>
		<path d="M152.502,0.001C68.412,0.001,0,68.412,0,152.501s68.412,152.5,152.502,152.5c84.089,0,152.5-68.411,152.5-152.5    S236.591,0.001,152.502,0.001z M152.502,280.001C82.197,280.001,25,222.806,25,152.501c0-70.304,57.197-127.5,127.502-127.5    c70.304,0,127.5,57.196,127.5,127.5C280.002,222.806,222.806,280.001,152.502,280.001z"/>
		<path d="M218.473,93.97l-90.546,90.547l-41.398-41.398c-4.882-4.881-12.796-4.881-17.678,0c-4.881,4.882-4.881,12.796,0,17.678    l50.237,50.237c2.441,2.44,5.64,3.661,8.839,3.661c3.199,0,6.398-1.221,8.839-3.661l99.385-99.385    c4.881-4.882,4.881-12.796,0-17.678C231.269,89.089,223.354,89.089,218.473,93.97z"/>
	</g>
</g>
</svg> Copied to clipboard!`);
    if (window.clipboardData && window.clipboardData.setData) {
      // IE specific code path to prevent textarea being shown while dialog is visible.
      return clipboardData.setData("Text", text);
    } else if (
      document.queryCommandSupported &&
      document.queryCommandSupported("copy")
    ) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  function makeCopyable() {
    const selector = `
    .copyable:not(.copyable--checked),
    span[style*="color: rgb(255, 255, 0)"]:not(.copyable--checked)`;

    document.querySelectorAll(selector).forEach((element) => {
      // Skip elements that contain other elements
      if (element.children.length > 0) return;

      // Mark element as processed
      element.classList.add("copyable--checked");
      element.setAttribute("data-tippy-content", "Click to copy");

      // Initialize Tippy.js
      const tooltip = tippy(element, {
        content: element.getAttribute("data-tippy-content"),
        placement: "top",
      });

      // Add event listener for copying
      element.addEventListener("click", function () {
        const textToCopy = this.textContent.trim();
        copyToClipboard(textToCopy);

        element.addEventListener("mouseleave", () => {
          tooltip.hide();
          setTimeout(() => {
            tooltip.setContent(element.getAttribute("data-tippy-content"));
          }, 250);
        });
      });
    });
  }

  function addToCart(variantID) {
    return new Promise((resolve, reject) => {
      const items = [{ quantity: 1, id: parseInt(variantID) }];

      fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          if (!response.ok) {
            // Parse error response from Shopify (if available)
            return response.json().then((errorData) => {
              throw new Error(
                errorData?.description ||
                  `Request failed with status ${response.status}`
              );
            });
          }
          return response.json();
        })
        .then((data) => {
          console.log("Product added to cart:", data);
          resolve(data); // Resolve the promise with the response data
        })
        .catch((error) => {
          console.error("Error occurred:", error.message);
          reject(error); // Reject the promise with the error
        });
    });
  }

  function isVariantInCart(variantID) {
    return new Promise((resolve, reject) => {
      // Fetch the current cart data from Shopify
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            // Handle errors from the fetch request
            return response.json().then((errorData) => {
              throw new Error(
                errorData?.description ||
                  `Request failed with status ${response.status}`
              );
            });
          }
          return response.json();
        })
        .then((cartData) => {
          // Check if the cart contains the specific variant ID
          const isInCart = cartData.items.some(
            (item) => item.variant_id === parseInt(variantID)
          );
          resolve(isInCart); // Resolve the promise with true/false
        })
        .catch((error) => {
          console.error("Error occurred while checking cart:", error.message);
          reject(error); // Reject the promise with the error
        });
    });
  }

  function handleQuickDownloadButton() {
    const $btn = document.querySelector(`.download-now-btn`);

    if (!$btn) {
      return;
    }

    $btn.addEventListener(`click`, async function (e) {
      e.preventDefault();
      const variantID = e.target.getAttribute(`data-variant-id`).trim();

      if (!variantID || variantID === "") {
        return;
      }

      const text = e.target.textContent;

      try {
        const isInCart = await isVariantInCart(variantID);

        if (!isInCart) {
          await addToCart(variantID);
        }

        window.location.href = "/checkout";
      } catch (err) {
        console.error(err);
      } finally {
        e.target.textContent = text;
      }
    });
  }

  function moveDOMElement(elementToMove, targetContainer) {
    // Check if both arguments are valid DOM elements

    if (
      !(elementToMove instanceof HTMLElement) ||
      !(targetContainer instanceof HTMLElement)
    ) {
      console.error("Both arguments must be valid DOM elements.");
      return;
    }

    // Move the element to the target container
    targetContainer.appendChild(elementToMove);
  }

  async function moveJudgeMeBelowProducts() {
    return;
    if (!isProductsPage()) {
      return;
    }
    const $judge = await _waitForElement(`#judgeme_product_reviews`);

    if (!$judge) {
      return;
    }

    $parent = document.querySelector(`.ezfy-judgeme-reviews`);

    if (!$parent) {
      return;
    }

    moveDOMElement($judge, $parent);
  }

  function loadToastify() {
    if (window.Toastify !== undefined) {
      return true;
    }

    return new Promise(async (resolve, reject) => {
      !(function (t, o) {
        "object" == typeof module && module.exports
          ? (module.exports = o())
          : (t.Toastify = o());
      })(this, function (t) {
        var o = function (t) {
          return new o.lib.init(t);
        };
        function i(t, o) {
          return o.offset[t]
            ? isNaN(o.offset[t])
              ? o.offset[t]
              : o.offset[t] + "px"
            : "0px";
        }
        function s(t, o) {
          return (
            !(!t || "string" != typeof o) &&
            !!(t.className && t.className.trim().split(/\s+/gi).indexOf(o) > -1)
          );
        }
        return (
          (o.defaults = {
            oldestFirst: !0,
            text: "Toastify is awesome!",
            node: void 0,
            duration: 3e3,
            selector: void 0,
            callback: function () {},
            destination: void 0,
            newWindow: !1,
            close: !1,
            gravity: "toastify-top",
            positionLeft: !1,
            position: "",
            backgroundColor: "",
            avatar: "",
            className: "",
            stopOnFocus: !0,
            onClick: function () {},
            offset: { x: 0, y: 0 },
            escapeMarkup: !0,
            ariaLive: "polite",
            style: { background: "" },
          }),
          (o.lib = o.prototype =
            {
              toastify: "1.12.0",
              constructor: o,
              init: function (t) {
                return (
                  t || (t = {}),
                  (this.options = {}),
                  (this.toastElement = null),
                  (this.options.text = t.text || o.defaults.text),
                  (this.options.node = t.node || o.defaults.node),
                  (this.options.duration =
                    0 === t.duration ? 0 : t.duration || o.defaults.duration),
                  (this.options.selector = t.selector || o.defaults.selector),
                  (this.options.callback = t.callback || o.defaults.callback),
                  (this.options.destination =
                    t.destination || o.defaults.destination),
                  (this.options.newWindow =
                    t.newWindow || o.defaults.newWindow),
                  (this.options.close = t.close || o.defaults.close),
                  (this.options.gravity =
                    "bottom" === t.gravity
                      ? "toastify-bottom"
                      : o.defaults.gravity),
                  (this.options.positionLeft =
                    t.positionLeft || o.defaults.positionLeft),
                  (this.options.position = t.position || o.defaults.position),
                  (this.options.backgroundColor =
                    t.backgroundColor || o.defaults.backgroundColor),
                  (this.options.avatar = t.avatar || o.defaults.avatar),
                  (this.options.className =
                    t.className || o.defaults.className),
                  (this.options.stopOnFocus =
                    void 0 === t.stopOnFocus
                      ? o.defaults.stopOnFocus
                      : t.stopOnFocus),
                  (this.options.onClick = t.onClick || o.defaults.onClick),
                  (this.options.offset = t.offset || o.defaults.offset),
                  (this.options.escapeMarkup =
                    void 0 !== t.escapeMarkup
                      ? t.escapeMarkup
                      : o.defaults.escapeMarkup),
                  (this.options.ariaLive = t.ariaLive || o.defaults.ariaLive),
                  (this.options.style = t.style || o.defaults.style),
                  t.backgroundColor &&
                    (this.options.style.background = t.backgroundColor),
                  this
                );
              },
              buildToast: function () {
                if (!this.options) throw "Toastify is not initialized";
                var t = document.createElement("div");
                for (var o in ((t.className =
                  "toastify on " + this.options.className),
                this.options.position
                  ? (t.className += " toastify-" + this.options.position)
                  : !0 === this.options.positionLeft
                  ? ((t.className += " toastify-left"),
                    console.warn(
                      "Property `positionLeft` will be depreciated in further versions. Please use `position` instead."
                    ))
                  : (t.className += " toastify-right"),
                (t.className += " " + this.options.gravity),
                this.options.backgroundColor &&
                  console.warn(
                    'DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.'
                  ),
                this.options.style))
                  t.style[o] = this.options.style[o];
                if (
                  (this.options.ariaLive &&
                    t.setAttribute("aria-live", this.options.ariaLive),
                  this.options.node &&
                    this.options.node.nodeType === Node.ELEMENT_NODE)
                )
                  t.appendChild(this.options.node);
                else if (
                  (this.options.escapeMarkup
                    ? (t.innerText = this.options.text)
                    : (t.innerHTML = this.options.text),
                  "" !== this.options.avatar)
                ) {
                  var s = document.createElement("img");
                  (s.src = this.options.avatar),
                    (s.className = "toastify-avatar"),
                    "left" == this.options.position ||
                    !0 === this.options.positionLeft
                      ? t.appendChild(s)
                      : t.insertAdjacentElement("afterbegin", s);
                }
                if (!0 === this.options.close) {
                  var e = document.createElement("button");
                  (e.type = "button"),
                    e.setAttribute("aria-label", "Close"),
                    (e.className = "toast-close"),
                    (e.innerHTML = "&#10006;"),
                    e.addEventListener(
                      "click",
                      function (t) {
                        t.stopPropagation(),
                          this.removeElement(this.toastElement),
                          window.clearTimeout(this.toastElement.timeOutValue);
                      }.bind(this)
                    );
                  var n =
                    window.innerWidth > 0 ? window.innerWidth : screen.width;
                  ("left" == this.options.position ||
                    !0 === this.options.positionLeft) &&
                  n > 360
                    ? t.insertAdjacentElement("afterbegin", e)
                    : t.appendChild(e);
                }
                if (this.options.stopOnFocus && this.options.duration > 0) {
                  var a = this;
                  t.addEventListener("mouseover", function (o) {
                    window.clearTimeout(t.timeOutValue);
                  }),
                    t.addEventListener("mouseleave", function () {
                      t.timeOutValue = window.setTimeout(function () {
                        a.removeElement(t);
                      }, a.options.duration);
                    });
                }
                if (
                  (void 0 !== this.options.destination &&
                    t.addEventListener(
                      "click",
                      function (t) {
                        t.stopPropagation(),
                          !0 === this.options.newWindow
                            ? window.open(this.options.destination, "_blank")
                            : (window.location = this.options.destination);
                      }.bind(this)
                    ),
                  "function" == typeof this.options.onClick &&
                    void 0 === this.options.destination &&
                    t.addEventListener(
                      "click",
                      function (t) {
                        t.stopPropagation(), this.options.onClick();
                      }.bind(this)
                    ),
                  "object" == typeof this.options.offset)
                ) {
                  var l = i("x", this.options),
                    r = i("y", this.options),
                    p = "left" == this.options.position ? l : "-" + l,
                    d = "toastify-top" == this.options.gravity ? r : "-" + r;
                  t.style.transform = "translate(" + p + "," + d + ")";
                }
                return t;
              },
              showToast: function () {
                var t;
                if (
                  ((this.toastElement = this.buildToast()),
                  !(t =
                    "string" == typeof this.options.selector
                      ? document.getElementById(this.options.selector)
                      : this.options.selector instanceof HTMLElement ||
                        ("undefined" != typeof ShadowRoot &&
                          this.options.selector instanceof ShadowRoot)
                      ? this.options.selector
                      : document.body))
                )
                  throw "Root element is not defined";
                var i = o.defaults.oldestFirst ? t.firstChild : t.lastChild;
                return (
                  t.insertBefore(this.toastElement, i),
                  o.reposition(),
                  this.options.duration > 0 &&
                    (this.toastElement.timeOutValue = window.setTimeout(
                      function () {
                        this.removeElement(this.toastElement);
                      }.bind(this),
                      this.options.duration
                    )),
                  this
                );
              },
              hideToast: function () {
                this.toastElement.timeOutValue &&
                  clearTimeout(this.toastElement.timeOutValue),
                  this.removeElement(this.toastElement);
              },
              removeElement: function (t) {
                (t.className = t.className.replace(" on", "")),
                  window.setTimeout(
                    function () {
                      this.options.node &&
                        this.options.node.parentNode &&
                        this.options.node.parentNode.removeChild(
                          this.options.node
                        ),
                        t.parentNode && t.parentNode.removeChild(t),
                        this.options.callback.call(t),
                        o.reposition();
                    }.bind(this),
                    400
                  );
              },
            }),
          (o.reposition = function () {
            for (
              var t,
                o = { top: 15, bottom: 15 },
                i = { top: 15, bottom: 15 },
                e = { top: 15, bottom: 15 },
                n = document.getElementsByClassName("toastify"),
                a = 0;
              a < n.length;
              a++
            ) {
              t =
                !0 === s(n[a], "toastify-top")
                  ? "toastify-top"
                  : "toastify-bottom";
              var l = n[a].offsetHeight;
              t = t.substr(9, t.length - 1);
              (window.innerWidth > 0 ? window.innerWidth : screen.width) <= 360
                ? ((n[a].style[t] = e[t] + "px"), (e[t] += l + 15))
                : !0 === s(n[a], "toastify-left")
                ? ((n[a].style[t] = o[t] + "px"), (o[t] += l + 15))
                : ((n[a].style[t] = i[t] + "px"), (i[t] += l + 15));
            }
            return this;
          }),
          (o.lib.init.prototype = o.lib),
          o
        );
      });
      //# sourceMappingURL=/sm/e1ebbfe1bf0b0061f0726ebc83434e1c2f8308e6354c415fd05ecccdaad47617.map
      while (!window.Toastify) {
        await new Promise((resolve) => setTimeout(resolve, 10));
      }

      resolve(true);
    });
  }

  function showToast(text = ``) {
    if (!window.Toastify) {
      return;
    }
    Toastify({
      text, // Customizable text
      duration: 2000, // Duration in milliseconds (3 seconds)
      gravity: "top", // Position: 'top' or 'bottom'
      position: "center", // Alignment: 'left', 'center', or 'right'
      backgroundColor: "linear-gradient(-45deg, #8731e8, #4528dc)", // Gradient background
      stopOnFocus: true, // Stop the timer when the user focuses on the toast
      escapeMarkup: false,
      className: `ezfy-toast`,
      closeOnClick: true,
    }).showToast();
  }

  return {
    test: test,
    showToast: showToast,
    scrollTo: scrollTo,
    wrapGistsWithDiv: wrapGistsWithDiv,
    loadTippy: loadTippy,
    handleQuickDownloadButton: handleQuickDownloadButton,
    init: function () {
      redirectOldWebsiteShop();
      redirectOldWebsiteBlog();
      if (isProductsPage()) {
        injectNoticeBox();
      }

      if (isProductsPage()) {
        cleanTabsInProductPageDescription();
        handleQuickDownloadButton();
      }

      document.addEventListener("DOMContentLoaded", function () {
        oneQuantityPerProduct();

        if (isBlogPage()) {
          wrapGistsWithDiv();
          renderGistsDynamically();
        }

        if (isProductsPage()) {
          productPageDropdown();
          moveJudgeMeBelowProducts();
        }
      });

      window.addEventListener("resize", function () {});

      window.addEventListener("load", function () {
        lazyLoadYoutubeIframe();
        loadTippy().then((_) => {
          if (isBlogPage()) {
            makeCopyable();
          }

          setTimeout(() => {
            initTooltips();
          }, 100);
        });

        loadToastify();
      });

      window.addEventListener("scroll", function () {});
    },
  };
})();

ezfy.init();
